import SubcontractorsService from "@/services/subcontractors.service"; //TODO: porządek z api

const state = {
  available: [],
  inprogress: false
};

const getters = {
  availableSubcontractors: state => {
    return state.available;
  },
};

const actions = {
  async loadAvailable({
    commit,
    state
  }) {
    
    if (state.inprogress === false && state.available.length === 0) {
      commit("inprogress");
      let subcontractors = await SubcontractorsService.available();
      commit("available", subcontractors);
    }
    return state.available;
  },
};


const mutations = {
  available(state, payload) {
    state.available = payload
    state.loading = false;
  },
  inprogress(state){
    state.inprogress = true;
  }
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
